/**
 * 计算百分比（返回0-1之间的小数）
 * @param value 当前值
 * @param total 总值
 * @returns 百分比值（0-1之间的小数）
 */

export const calculatePercentage = (value: number, total: number): number => {
  if (total === 0) {
    return 0;
  }
  const percentage = value / total;
  return Math.max(Math.min(percentage, 1), 0);
};
